import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";
import classnames from "classnames";

import { AppConfig } from "../../constants";
import { useQueryURL } from "../../hooks/useQueryURL";
import { FlagButton } from "./components";
import { PrivacyPolicyPageAU } from "./pages/au";
import { PrivacyPolicyPageCN } from "./pages/cn";
import useStyles from "./styles";
import { FlagCode, QueryUrlParams } from "./types";

export const PrivacyPolicy = () => {
  const classes = useStyles();
  const queries = useQueryURL<QueryUrlParams>();

  const [renderHeader, setRenderHeader] = useState(true);
  const [languageCodeSelected, setLanguageCodeSelected] = useState<FlagCode>(FlagCode.AU);

  const Flags = [
    { code: FlagCode.AU, label: "Australia", onClick: () => setLanguageCodeSelected(FlagCode.AU) },
    { code: FlagCode.CN, label: "China", onClick: () => setLanguageCodeSelected(FlagCode.CN) },
  ];

  useEffect(() => {
    const { hideHeader } = queries("hideHeader");

    if (hideHeader) setRenderHeader(false);
  }, []);

  const getPageTitleByLanguageCode = () => {
    switch (languageCodeSelected) {
      case FlagCode.AU:
        return `Privacy Policy`;
      case FlagCode.CN:
        return "隐私政策";
      default:
        return "null";
    }
  };

  const renderContentPages = () => {
    switch (languageCodeSelected) {
      case FlagCode.AU:
        return <PrivacyPolicyPageAU />;
      case FlagCode.CN:
        return <PrivacyPolicyPageCN />;
      default:
        return null;
    }
  };

  return (
    <Grid container flexDirection="column" className={classes.container}>
      {!renderHeader && (
        <Grid item container direction="row" mb={2}>
          {Flags.map((flag) => (
            <FlagButton key={flag.code} {...flag} />
          ))}
        </Grid>
      )}

      {renderHeader && (
        <Grid item container flexDirection="column">
          <img
            src={AppConfig.appLogo}
            alt="session-logo"
            data-cy="sessionLogo"
            className={classnames("img-fluid", classes.image)}
          />

          <Grid item container direction="row">
            {Flags.map((flag) => (
              <FlagButton key={flag.code} {...flag} />
            ))}
          </Grid>

          <span className={(classes.text, classes.title)}>{getPageTitleByLanguageCode()}</span>
        </Grid>
      )}

      {renderContentPages()}
    </Grid>
  );
};
